import React, { PureComponent } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormData, Module } from 'components/misc'
import { AJEventSettingsModal } from 'components/modals'
import MODALS from 'constants/modals'

export default class AJEventOverview extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isTemplate: PropTypes.bool
  }

  render () {
    const { data, isTemplate } = this.props

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': () => this.props.modal(MODALS.AJ_EVENT_SETTINGS),
        'iconAction': 'settings',
        'isActionLoading': null,
        'intlKeyAction': isTemplate
          ? 'button.adventurous_journey_template_settings'
          : 'button.adventurous_journey_settings',
        'action': 'Event Settings'
      }
    ]

    return (
      <div>
        <Module
          primary={!isTemplate}
          grid={!isTemplate}
          action="Event Settings"
          buttonDefinition={buttonDefinition}
        >
          {!isTemplate &&
            <div className="row">
              <div className="col-xs-4">
                <FormData label="Created by" intlKey="label.created_by">
                  {get(data, 'detail.createdByPerson.firstName')}
                  {' '}
                  {get(data, 'detail.createdByPerson.lastName')}
                </FormData>
              </div>
            </div>}
        </Module>
        <AJEventSettingsModal
          modalId={MODALS.AJ_EVENT_SETTINGS}
          modal={this.props.modal}
          data={data}
          onDelete={this.props.onDelete}
          isTemplate={isTemplate}
        />
      </div>
    )
  }
}
